import { render, staticRenderFns } from "./MemberIcon.vue?vue&type=template&id=507de43e"
import script from "./MemberIcon.vue?vue&type=script&lang=js"
export * from "./MemberIcon.vue?vue&type=script&lang=js"
import style0 from "./MemberIcon.vue?vue&type=style&index=0&id=507de43e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports